<template>
<!-- <el-main> -->
  <div class="product">
    
    <div class="banner">
      <div class="container">
        <div class="text">
          <h5>综合能源服务平台</h5>
          <h6>ZONG HE NENG YUAN FU WU PING TAI</h6>
          <p>全面感知 综合赋能</p>
        </div>
        <figure class="img">
          <img src="../../assets/img/product2-banner.png" alt />
        </figure>
      </div>
    </div>
    <div class="product-content">
    <!-- 平台亮点 -->
      <div class="mainbox indexValue HightLight">
        <div class="container">
          <h5 class="mainbox-ti">平台亮点</h5>
          <div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="box h200">
                  <h5>
                    <img src="../../assets/img/product-group_4-icon_1.png" alt />
                  </h5>
                  <h6>先进的技术平台</h6>
                  <p>
                    感知层、网络层、平台层、应用层分层设计，云边端协同计算、大数据、物联网、边缘计算、人工智能、区块链等多种技术融合。
                  </p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="box h200">
                  <h5>
                    <img src="../../assets/img/product-group_4-icon_1.png" alt />
                  </h5>
                  <h6>先进的技术平台</h6>
                  <p>
                    感知层、网络层、平台层、应用层分层设计，云边端协同计算、大数据、物联网、边缘计算、人工智能、区块链等多种技术融合。
                  </p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="box h200">
                  <h5>
                    <img src="../../assets/img/product-group_4-icon_1.png" alt />
                  </h5>
                  <h6>先进的技术平台</h6>
                  <p>
                    感知层、网络层、平台层、应用层分层设计，云边端协同计算、大数据、物联网、边缘计算、人工智能、区块链等多种技术融合。
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>

          <div style="margin-top: 50px">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="box h200">
                  <h5>
                    <img src="../../assets/img/product-group_4-icon_1.png" alt />
                  </h5>
                  <h6>先进的技术平台</h6>
                  <p>
                    感知层、网络层、平台层、应用层分层设计，云边端协同计算、大数据、物联网、边缘计算、人工智能、区块链等多种技术融合。
                  </p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="box h200">
                  <h5>
                    <img src="../../assets/img/product-group_4-icon_1.png" alt />
                  </h5>
                  <h6>先进的技术平台</h6>
                  <p>
                    感知层、网络层、平台层、应用层分层设计，云边端协同计算、大数据、物联网、边缘计算、人工智能、区块链等多种技术融合。
                  </p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="box h200">
                  <h5>
                    <img src="../../assets/img/product-group_4-icon_1.png" alt />
                  </h5>
                  <h6>先进的技术平台</h6>
                  <p>
                    感知层、网络层、平台层、应用层分层设计，云边端协同计算、大数据、物联网、边缘计算、人工智能、区块链等多种技术融合。
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心功能 -->
    <div class="mainbox indexFunction">
      <div class="container">
        <h5 class="mainbox-ti">核心功能</h5>
        <!-- <ul class="nav nav-pills mb-3" id="pill-tab" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="pills-home-tab" data-toggle="pill" href="" role="tab" aria-controls="pills-A" aria-selected="false">
                        <i class="iconfont icon-icon01">客户服务</i>
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="pills-home-tab" data-toggle="pill" href="" role="tab" aria-controls="pills-A" aria-selected="false">
                        <i class="iconfont icon-icon01">客户服务</i>
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="pills-home-tab" data-toggle="pill" href="" role="tab" aria-controls="pills-A" aria-selected="false">
                        <i class="iconfont icon-icon01">客户服务</i>
                    </a>
                </li>
            </ul> -->
        <!-- <el-container>
          <el-main>3</el-main>
          <el-aside> -->
            <div class="mainbox-tabs">
              <el-tabs type="card" :tab-position="tabPosition">
                <el-tab-pane label="运行监视">
                  <img class="tabs-img" src="../../assets/img/product/2_1.png" />
                </el-tab-pane>
                <el-tab-pane label="调度指挥">
                   <img class="tabs-img" src="../../assets/img/product/2_2.png" />
                </el-tab-pane>
                <el-tab-pane label="能量管理">
                  <img class="tabs-img" src="../../assets/img/product/2_3.png" />
                </el-tab-pane>
                <el-tab-pane label="数据分析">
                  <img class="tabs-img" src="../../assets/img/product/2_4.png" />
                </el-tab-pane>
              </el-tabs>
            </div>
           
          <!-- </el-aside>
        </el-container> -->
      </div>
    </div>
    
  </div>
<!-- </el-main> -->
</template>

<script>
export default {
  name: "Product2",
  data() {
    return {
      tabPosition: "right",
    };
  },
};
</script>

<style scoped>
.el-tabs--right.el-tabs--card .el-tabs__nav {
    border-left: ;
}

 .el-tabs__item.is-active {
    color: #01BF86;
  }

/deep/.el-tabs__item {
     color: #fff;
 }

.el-tabs--card>.el-tabs__header {
    /* border-bottom: 1px solid #E4E7ED; */
    background-color: #2574eb;
}

.mainbox-tabs .tabs-img {
  width: 980px;
}

.product {
  width: 100%;
  height: 100%;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}

.container {
  width: 1200px;
  max-width: 1200px;
  padding: 0;
}

/* element-ui */
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

/* 
    banner
*/
.banner {
  width: 100%;
  height: 360px;
  background: #2f9eff;
}
.banner .container {
  position: relative;
  margin: 0 auto; 
  height: 360px;
}
.banner .text {
  position: absolute;
  
  left: 150px;
  top: 50%;
  transform: translate(0, -50%);
  color: #fff;
}
.banner .text h5 {
  font-size: 34px;
  font-weight: bold;
  letter-spacing: 2.5px;
}
.banner .text h6 {
  font-size: 12px;
  margin: 12px 0 20px;
  font-weight: bold;
  opacity: 0.5;
  letter-spacing: 1.5px;
}
.banner .text p {
  font-size: 16px;
  letter-spacing: 2px;
}
.banner .img {
  position: absolute;
  right: 150px;
  bottom: -30px;
}

/* 
    mainbox
*/
.mainbox {
  padding: 90px 0;
}
.mainbox-gray {
  background: #fbfbfb;
}
.mainbox-ti {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  position: relative;
  width: 400px;
  margin: 0 auto 60px;
}
.mainbox-ti::before {
  content: "";
  width: 120px;
  height: 4px;
  background: linear-gradient(to right, #f6f6f6, #ebebeb);
  position: absolute;
  left: 0;
  top: 50%;
}
.mainbox-ti::after {
  content: "";
  width: 120px;
  height: 4px;
  background: linear-gradient(to left, #f6f6f6, #ebebeb);
  position: absolute;
  right: 0;
  top: 50%;
}
.mainbox-tabs {
  margin-left: 50px;
}

/* 
    indexValue
*/
.indexValue {
}
.indexValue .container {
  width: 1260px;
  max-width: 1260px;
}
.indexValue .box {
  box-shadow: 0 0 20px #f0f0f0;
  position: relative;
  padding: 50px 40px 40px;
  border-radius: 15px;
}
.indexValue .box h5 {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, -50%);
  width: 180px;
  line-height: 40px;
  background: linear-gradient(to right, #0f6eda, #3ec87d);
  text-align: center;
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
}
.indexValue .box .li {
  overflow: hidden;
  margin-bottom: 30px;
  line-height: 1.8em;
}
.indexValue .box .li:last-child {
  margin-bottom: 0;
}
.indexValue .box span {
  font-size: 15px;
  font-weight: bold;
  float: left;
  width: 80px;
}
.indexValue .box span.num {
  color: #0f71d6;
}
.indexValue .box span.num img {
  margin-left: 5px;
  transform: translate(0, -1px);
}
.indexValue .box .font {
  background: linear-gradient(to right, #0f6eda, #21af63);
  -webkit-background-clip: text;
  color: transparent;
}
.indexValue .box p {
  font-size: 15px;
  color: #666;
  float: right;
  width: 440px;
  text-align: justify;
}

.one-pic {
  max-width: 1080px;
  margin: 0 auto;
  display: block;
}
.one-pic img {
  max-width: 100%;
}

/* 
    HightLight
*/
/* .HightLight .row {
  margin-top: 80px;
} */
/* .HightLight .col-xl-4 {
  margin-bottom: 60px;
}
.HightLight .col-xl-4:nth-child(n + 4) {
  margin-bottom: 0;
} */
.HightLight .box {
  padding: 60px 40px 40px;
}
.HightLight .box h5 {
  background: #218eed;
  font-size: 16px;
  width: 72px;
  line-height: 72px;
  height: 72px;
  border-radius: 50%;
}
.HightLight .box h6 {
  font-size: 18px;
  text-align: center;
  margin-bottom: 15px;
  font-weight: bold;
  color: #333;
}
.HightLight .box span {
  float: none;
  color: #fff;
  display: inline-block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-51%, -51%);
  font-size: 14px;
}
.HightLight .box p {
  width: 100%;
  float: none;
  line-height: 1.8em;
  color: #888;
}
.HightLight .box img {
  padding-top: 15px;
  width: 42px;
}

/* 
    indexFunction
*/
.indexFunction {
  overflow: hidden;
  background: url("../../assets/img/bg03.jpg") no-repeat;
  width: 100%;
  height: auto;
  background-size: cover;
  background-position: 0 0;
  
}
.indexFunction .mainbox-ti {
  color: #fff;
}
.indexFunction .container {
  width: 1200px;
  margin: 0 auto;
}
.indexFunction .nav {
  width: 160px;
  float: right;
}
.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}
.indexFunction .nav .nav-item {
  width: 100%;
  margin-bottom: 5px;
}
.indexFunction .nav .nav-link {
  width: 100%;
  font-size: 14px;
  line-height: 48px;
  height: 48px;
  padding: 0 10px;
  background: #135ecf;
  color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  position: relative;
}
.indexFunction .nav .nav-link:hover {
  color: #fff;
  background: #2574eb;
}
.indexFunction .nav .nav-link.active {
  background: #fff;
  color: #135ecf;
  border-radius: 0 5px 5px 0;
  font-weight: bold;
}
.indexFunction .nav .nav-link.active:hover {
  background: #fff;
  color: #135ecf;
}
.indexFunction .nav .nav-link.active::after {
  content: "";
  width: 24px;
  height: 48px;
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 24px 0 0 24px;
  animation: ww 0.3s;
  transform: translate(-20px, 0);
}
.indexFunction .nav .nav-link .iconfont {
  margin-right: 5px;
}

.indexFunction .tab-content {
  width: 980px;
  float: left;
  background: #fff;
  border-radius: 5px;
  padding: 40px 40px 0;
  min-height: 685px;
}
.indexFunction .tab-content .ti {
  font-size: 24px;
  letter-spacing: 3px;
}
.indexFunction .tab-content .ti .iconfont {
  background: linear-gradient(to right, #0f6eda, #21af63);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 24px;
}
.indexFunction .tab-content .text {
  margin: 20px 0;
}
.indexFunction .tab-content .text p {
  font-size: 16px;
  color: #666;
  line-height: 1.8em;
  text-align: justify;
}
.indexFunction .tab-content .img {
  background: #f6f6f6;
  width: 100%;
  height: 500px;
  position: relative;
}
.indexFunction .tab-content .img img {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
}
.indexFunction .tab-content .imgB {
  width: 100%;
  height: 152px;
}
.indexFunction .tab-content .imgB img {
  padding: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.indexFunction .tab-content .imgB p {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  line-height: 30px;
  padding: 0 10px;
  color: #fff;
  background: linear-gradient(to right, #253e7d, rgba(255, 255, 255, 0));
}
/* .indexFunction .tab-content .col-xl-4 {
  margin-bottom: 30px;
}
.indexFunction .tab-content .col-xl-4:nth-child(n + 4) {
  margin-bottom: 0;
} */

/* 
    indexCase
*/
.indexCase {
  overflow: hidden;
}
.indexCase .container {
  width: 1000px;
}
.indexCase .nav {
  width: 160px;
  float: left;
}
.indexCase .nav .nav-item {
  width: 100%;
  margin-bottom: 5px;
  border-radius: 5px;
  overflow: hidden;
}
.indexCase .nav .nav-link {
  width: 100%;
  height: 80px;
  padding: 0;
  display: block;
}
.indexCase .nav .nav-link .img {
  width: 100%;
  position: relative;
  height: 100%;
}
.indexCase .nav .nav-link .img img {
  width: 100%;
  height: 80px;
  object-fit: cover;
  object-position: center;
  position: absolute;
  left: 0;
  top: 0;
}
.indexCase .nav .nav-link .img p {
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  color: #fff;
  text-align: center;
  line-height: 30px;
  transition: all 0.3s;
}
.indexCase .nav .nav-link.active .img p {
  background: #218eed;
  color: #fff;
}
.indexCase .nav .nav-link:hover .img p {
  background: #218eed;
  color: #fff;
}

.indexCase .tab-content {
  width: 750px;
  float: right;
}
.indexCase .tab-content .ti {
  font-size: 24px;
  letter-spacing: 3px;
}
.indexCase .tab-content .ti span {
  background: linear-gradient(to right, #0f6eda, #21af63);
  -webkit-background-clip: text;
  color: transparent;
}
.indexCase .tab-content .text {
  margin: 30px 0;
}
.indexCase .tab-content .text p {
  font-size: 16px;
  color: #666;
  line-height: 1.8em;
  text-align: justify;
}
.indexCase .tab-content .img {
  margin: 0 auto;
  display: table;
}
.indexCase .tab-content .con {
  margin-top: 30px;
}
.indexCase .tab-content .con .box {
  box-shadow: 0 0 20px #f0f0f0;
  padding: 30px;
  border-radius: 10px;
}
.indexCase .tab-content .sti {
  font-size: 18px;
  text-align: center;
  letter-spacing: 0;
  display: table;
  margin: 0 auto 20px;
  position: relative;
  padding: 0 20px;
}
.indexCase .tab-content .sti::before {
  content: "";
  width: 6px;
  height: 6px;
  background: #218eed;
  position: absolute;
  left: 0;
  top: 50%;
  border-radius: 50%;
  transform: translate(0, -50%);
}
.indexCase .tab-content .sti::after {
  content: "";
  width: 6px;
  height: 6px;
  background: #218eed;
  position: absolute;
  right: 0;
  top: 50%;
  border-radius: 50%;
  transform: translate(0, -50%);
}
.indexCase .tab-content .con .box p {
  font-size: 14px;
  color: #666;
  line-height: 2em;
}
.indexCase .tab-content .table {
  margin-top: 60px;
}
.indexCase .tab-content .table .box {
  margin-top: 30px;
}
.indexCase .tab-content .table .ssti {
  line-height: 50px;
  font-size: 16px;
  background: #218eed;
  color: #fff;
  padding: 0 20px;
}
.indexCase .tab-content .table .li {
  line-height: 50px;
  overflow: hidden;
}
.indexCase .tab-content .table .li:nth-child(even) {
  background: #e6f2fe;
}
.indexCase .tab-content .table .li:nth-child(odd) {
  background: #f7faff;
}
.indexCase .tab-content .table .li p {
  float: left;
  width: 50%;
  font-size: 14px;
  color: #666;
  padding: 0 20px;
}
.indexCase .tab-content .table .li p:first-child {
  border-right: solid 1px #fff;
}

/* 
    bottom-wrap
*/
.bottom-wrap {
  width: 100%;
  padding-top: 35px;
  height: 260px;
  background-color: #2f2f3b;
  color: #fff;
  font-size: 13px;
}
.bottom-wrap .content-wrap {
  float: left;
  padding-top: 34px;
  width: calc(100% - 120px);
  text-align: center;
  color: #acacb1;
  line-height: 2;
}
.bottom-wrap .ewm-img {
  width: 120px;
  height: 120px;
}
.bottom-wrap .ewm-wrap {
  float: left;
  left: 30px;
  position: relative;
}
.bottom-wrap .title {
  font-size: 16px;
}

/* 
    Mobile
*/
@media all and (max-width: 768px) {
  .container {
    width: 100%;
    max-width: 100%;
  }
  .mainbox {
    padding: 60px 15px;
  }
  .mainbox-ti {
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    position: relative;
    width: 100%;
    margin: 0 auto 60px;
  }
  .mainbox-ti::before {
    display: none;
  }
  .mainbox-ti::after {
    display: none;
  }
  .h170 {
    height: auto;
  }
  .h200 {
    height: auto;
  }
  .h250 {
    height: auto;
  }
  .h300 {
    height: auto;
  }

  .banner {
    height: auto;
    padding: 30px 20px;
    margin-top: 70px;
  }
  .banner .container {
    height: auto;
  }
  .banner .text {
    position: static;
    transform: translate(0, 0);
  }
  .banner .img {
    position: static;
    margin-top: 30px;
  }
  .banner .img img {
    width: 100%;
  }

  /* .row {
    margin: 0;
  }
  .col-xl-6 {
    padding: 0;
  }
  .col-xl-4 {
    padding: 0;
  }
  .col-xl-3 {
    padding: 0;
  } */

  .head-outwrap {
    overflow: unset;
    height: 70px;
    z-index: 999;
    border-bottom: 1px solid #ddd;
    z-index: 99;
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
  }
  .head-outwrap::after {
    content: "";
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    z-index: 99;
    display: none;
  }
  .logo-wrap {
    position: absolute;
    left: 15px;
    top: 0;
    line-height: 70px;
    display: block;
    height: auto;
    float: none;
    width: 150px;
    margin-top: 0;
  }
  .logo-wrap img {
    height: auto;
    line-height: 70px;
    width: 100%;
  }
  .nav-wrap {
    float: none;
    background: #fff;
    display: none;
    position: absolute;
    left: 0;
    top: 70px;
    width: 100%;
    padding: 10px 0;
    margin-left: 0;
    z-index: 99;
  }
  .nav-wrap ul {
    padding: 0;
  }
  .nav-wrap li {
    float: none;
    margin: 0;
    line-height: 56px;
    padding: 5px 20px;
    width: 100%;
  }
  .nav-wrap a {
    border-radius: 5px;
    border-bottom: 1px solid #ddd;
    display: block;
  }
  .head-outwrap .menu-bt {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    display: block;
    width: 50px;
    line-height: 70px;
    text-align: center;
  }
  .head-outwrap .menu-bt i {
    font-size: 30px;
  }
  .head-outwrap .menu-bt:active i {
    color: #2663ff;
  }
  .headerBg {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    z-index: 98;
  }
  .login-wrap {
    float: none;
    position: absolute;
    right: 55px;
    top: 50%;
    background: #fff;
    transform: translate(0, -50%);
    display: none;
  }
  .login-wrap a {
    margin: 0;
  }

  .indexValue .container {
    width: 100%;
    max-width: 100%;
  }
  .indexValue .box {
    padding: 40px 20px;
  }
  .indexValue .box span {
    float: none;
  }
  .indexValue .box p {
    float: none;
    width: 100%;
  }
  .indexValue .col-12:nth-child(1) {
    margin-bottom: 60px;
  }

  .one-pic {
    max-width: 100%;
  }
  .one-pic img {
    width: 100%;
  }

  .indexFunction .container {
    width: 100%;
  }
  .indexFunction .nav {
    width: 100%;
    float: none;
    display: flex;
    margin: 0 -2.5px;
  }
  .indexFunction .nav .nav-item {
    flex: 0 0 50%;
    max-width: 0 0 50%;
    padding: 0 2.5px;
  }
  .indexFunction .tab-content {
    width: 100%;
    float: none;
    min-height: auto;
    padding: 30px 25px;
  }
  .indexCase .container {
    width: 100%;
  }
  .indexCase .nav {
    width: 100%;
    float: none;
  }
  .indexCase .tab-content {
    width: 100%;
    float: none;
  }
  .indexCase .nav {
    width: 100%;
    float: none;
    display: flex;
    margin: 0 -2.5px;
  }
  .indexCase .nav .nav-item {
    flex: 0 0 50%;
    max-width: 0 0 50%;
    padding: 0 2.5px;
  }

  .indexCase .tab-content .img img {
    width: 100%;
  }
  .indexFunction .tab-content .col-12 {
    margin-bottom: 20px;
  }
  .indexFunction .tab-content .img {
    height: 200px;
  }

  .HightLight h6 {
    margin-top: 15px;
  }
  /* .HightLight .col-xl-4:nth-child(n + 4) {
    margin-bottom: 60px;
  }
  .HightLight .col-xl-4:last-child {
    margin-bottom: 0;
  } */

  .bottom-wrap {
    width: 100%;
    height: auto;
    padding: 35px 15px;
    text-align: center;
  }
  .bottom-wrap .content-wrap {
    float: none;
    padding-top: 34px;
    width: auto;
    text-align: center;
    color: #acacb1;
    line-height: 2;
  }
  .bottom-wrap .ewm-img {
    width: 120px;
    height: 120px;
  }
  .bottom-wrap .ewm-wrap {
    float: none;
    left: 30px;
    position: static;
  }
  .bottom-wrap .title {
    font-size: 16px;
    margin-bottom: 20px;
  }
}

@media all and (min-width: 1280px) and (max-width: 1366px) {
}

@media all and (min-width: 1380px) and (max-width: 1440px) {
}
</style>